// extracted by mini-css-extract-plugin
module.exports = {"token":"token__token___3BApH","removeToken":"token__removeToken___2bcjo"};